import {
  /* useCallback, */ useCallback,
  useEffect,
  useId,
  useRef,
  useState,
} from "react";
import {
  Container,
  SearchBarSection,
  SearchBarSectionSubcontainer,
} from "./styles";
import SearchBar from "../../../../../components/ui-v2/Inputs/Search";
import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import DropdownFilter from "../../../../../components/ui-v2/DropdownFilter";
import {
  /* Table , */ TCellNotTagMiscellaneous,
  TCellStyleVariants,
  TTableBody,
} from "../../../../../components/ui-v2/TableGrid";
import {
  breakStringPreserveSpaces,
  cnpjMask,
} from "../../../../../utils/formatters";

import {
  TInvoice,
  TInvoiceEntryStatus,
  TPaymentSlip,
  setAttachedInvoices,
  setInvoicesUpdatedAt,
  setPaymentSlipsUpdatedAt,
  setToastState,
} from "../../../../../redux/reducers/globalState";
import { useTypedDispatch } from "../../../../../hooks/useTypedDispatch";
import {
  fetchInvoices,
  fetchModalPaymentSlips,
} from "../../../../../redux/actions";
import {
  CALENDAR_SLIP_CONTENT_OPTIONS,
  TCalendarMenuOptions,
} from "../../../../../components/ui-v2/DropdownFilter/Menu";
import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
import {
  getQuerystringParams,
  handleParseQuerystrings,
  handleParseToDateCalendarOptions,
  handleRevertTranslateCalendarOptions,
  handleSetDataToLocalStorage,
  handleSetEndDate,
  handleTranslateCalendarOptions,
  TQuerystringParams,
} from "../../../../../utils/miscellaneous";
import { localStorageConstants } from "../../../../../utils/constants";

import TableGrid from "../../../../../components/ui-v2/TableGrid";
import apiService from "../../../../../services/api";

import { TButtonIconVariants, TButtonProps } from "../../../Button";
import { UilAngleDown, UilCopyAlt } from "@iconscout/react-unicons";
import AttachmentMenu from "../../../Menus/AttachmentMenu";
import { ROUTES } from "../../../../../router";
import Modal from "../..";
import Tooltip from "../../../Tooltip";
import axios, { CancelTokenSource } from "axios";
import { parseISO } from "date-fns/parseISO";
import { useNavigationManager } from "../../../../../hooks/useNavigationManager";

export type TLinkPaymentSlipProps = {
  footer: {
    buttons: TButtonProps<TButtonIconVariants>[];
  };
  onClear: (clearFunction: () => void) => void;
};

const LinkPaymentSlip: React.FC<TLinkPaymentSlipProps> = ({
  footer,
  /* onClear, */
}) => {
  const dispatch = useTypedDispatch();

  // Add refs for filter state and setSelected
  const entryStatusFilterRef = useRef<string[]>([]);
  const entryStatusSetSelectedRef = useRef<React.Dispatch<
    React.SetStateAction<string[]>
  > | null>(null);

  const { goTo, setQuerystring } = useNavigationManager();

  const cancelTokenSource = useRef<CancelTokenSource | null>(null);

  const prevQueryStringsRef = useRef<TQuerystringParams | null>(null);

  const {
    modalPaymentSlipState,
    attachedInvoices,
    selectOrganization,
    selectedOrganizationWithPermissions,
  } = useTypedSelector((state) => state.globalState.data);

  const isLoading = useTypedSelector(
    (state) => state.globalState.isLoadingModalPaymentSlips
  );

  const startDateRef = useRef<string | undefined>();
  const endDateRef = useRef<string | undefined>();
  const entryStatusRef = useRef<TInvoiceEntryStatus | undefined>(10);
  const payablesRef = useRef<boolean | undefined>();
  const goodsEntryRef = useRef<boolean | undefined>();
  const pageRef = useRef(1);
  const itemsPerPageRef = useRef(100);
  const searchRef = useRef<string | undefined>();

  const allPaymentSlipsRef = useRef<TPaymentSlip[]>([]);

  const searchBarContainerId = useId();

  const [invoiceToBreakLink, setInvoiceToBreakLink] = useState<
    | {
        target: TInvoice;
        origin: TPaymentSlip;
      }
    | undefined
  >();

  const [shouldShowAttachmentMenu, setShouldShowAttachmentMenu] = useState("");

  const [selectedPaymentSlipRows, setSelectedPaymentSlipRows] = useState<
    TPaymentSlip[]
  >([]);

  const [selectedUUIDs, setSelectedUUIDs] = useState<string[]>([]);

  const [shouldUpdateComponent, setShouldUpdateComponent] = useState(false);

  const [shouldRejectFilledEntryStatus /* setShouldRejectFilledEntryStatus */] =
    useState(false);

  const entryStatusOptions = ["Sem lançamentos", "Contas a pagar lançada"];

  const rowFormatter = (paymentSlip: TPaymentSlip, index: number) => {
    return [
      {
        style: "default",
        value: paymentSlip.process_date
          ? format(parseISO(paymentSlip?.process_date), "dd/MM/yyyy")
          : "-",
      },
      {
        style: "default",
        value: paymentSlip.source.length > 0 ? paymentSlip.source : "-",
      },
      {
        style: "miscellaneous",
        tooltip: paymentSlip.provider_name && {
          text: (() => {
            const values = breakStringPreserveSpaces(
              paymentSlip.provider_name,
              24
            );

            return values.map((value, index) => ({
              style: "default",
              text: value,
              shouldBreakLine: index !== values.length - 1,
            }));
          })(),
          customTopPosition: index * 96 + 85,
          hasScrollableRef: true,
        },
        values: [
          {
            style: "bold",
            text: paymentSlip.provider_name ? paymentSlip?.provider_name : "-",
            shouldBreakLine: true,
          },
          {
            style: "default",
            text: paymentSlip.provider_document
              ? cnpjMask(paymentSlip?.provider_document)
              : "-",
            shouldBreakLine: false,
          },
        ],
      },
      {
        style: "default",
        value: paymentSlip.amount
          ? "R$ " + paymentSlip?.amount.replace(".", ",")
          : "-",
      },
      {
        style: "default",
        value: paymentSlip.due_date
          ? format(parseISO(paymentSlip?.due_date), "dd/MM/yyyy")
          : "-",
      },
    ] as TTableBody<TCellStyleVariants>[];
  };

  const handleSecondRowLeftSideCustomNodeRender = (
    paymentSlip: TPaymentSlip,
    _index: number
  ) => {
    return (
      <span>
        <Tooltip
          text={[{ text: "Copiar", style: "default", shouldBreakLine: false }]}
        >
          <button
            role="button"
            onClick={() => {
              navigator.clipboard.writeText(paymentSlip.bar_code).then(() => {
                dispatch(
                  setToastState({
                    variant: "success",
                    message: {
                      title: "Sucesso",
                      description: "Linha digitável copiada",
                    },
                    shouldShow: true,
                  })
                );
              });
            }}
          >
            <UilCopyAlt />
          </button>
        </Tooltip>
      </span>
    );
  };

  const handleSecondRowRightSideCustomNodeRender = (
    paymentSlip: TPaymentSlip,
    rowIndex: number
  ) => {
    return paymentSlip.invoices_exists ? (
      <span>
        <button
          role="button"
          onClick={() => {
            apiService
              .getPaymentSlipAttachedInvoices(
                paymentSlip.uuid,
                (cancelTokenSource.current as CancelTokenSource).token
              )
              .then((response: any) => {
                dispatch(setAttachedInvoices(response.data));
                setShouldShowAttachmentMenu(`${rowIndex}`);
              });
          }}
        >
          Ver notas fiscais <UilAngleDown />
        </button>

        <AttachmentMenu
          position={{ top: 214 + 100 * rowIndex - 3 * rowIndex + "px" }}
          shouldShowMenu={
            shouldShowAttachmentMenu === `${rowIndex}` &&
            attachedInvoices.length > 0
          }
          onClickAway={() => {
            setShouldShowAttachmentMenu("");
          }}
          items={attachedInvoices.map((invoice: TInvoice) => {
            return {
              onDelete:
                invoice.fintera_id && invoice.fintera_id.length > 0
                  ? undefined
                  : () => {
                      setInvoiceToBreakLink({
                        target: invoice,
                        origin: paymentSlip,
                      });
                    },
              name: invoice.label,
              searchParam: invoice.access_key,
              url: ROUTES.INVOICES + window.location.search + "&period=all",
            };
          })}
        />
      </span>
    ) : (
      <span>
        <p>Nenhuma nota vinculada</p>
      </span>
    );
  };

  const secondRowFormatter = (invoice: TPaymentSlip) => ({
    style: "miscellaneous",
    values: [
      {
        style: "default",
        text: "Linha digitável: ",
        shouldBreakLine: false,
      },
      {
        style: "faded",
        text:
          invoice.bar_code.length > 0 ? invoice.bar_code : "(Não identificada)",
        shouldBreakLine: false,
      },
    ],
  });

  const handleCalendarOnClear = () => {
    const querystring = getQuerystringParams();

    startDateRef.current = undefined;
    endDateRef.current = undefined;
    delete querystring.start_date;
    delete querystring.end_date;
    querystring.period = "all";

    setQuerystring(querystring);

    updateAllPaymentSlipsRef();
  };

  const handleCalendarOnSelect = (selected: string[]) => {
    const select = selected as TCalendarMenuOptions[];

    const querystring = getQuerystringParams();

    if (CALENDAR_SLIP_CONTENT_OPTIONS.includes(select[0])) {
      const tempStartDate = handleParseToDateCalendarOptions(select[0]);

      if (tempStartDate === undefined) {
        startDateRef.current = undefined;
        endDateRef.current = undefined;

        delete querystring.start_date;
        delete querystring.end_date;
        querystring.period = "all";

        if (querystring.page) {
          querystring.page = 1;
        }

        setQuerystring(querystring);
        updateAllPaymentSlipsRef();
      } else {
        const formatTempStartDate = format(tempStartDate, "yyyy-MM-dd");
        if (formatTempStartDate !== startDateRef.current) {
          const formatEndDate = handleSetEndDate(select[0]);

          startDateRef.current = formatTempStartDate;
          if (formatEndDate !== endDateRef.current)
            endDateRef.current = formatEndDate;

          querystring.period = handleTranslateCalendarOptions(
            select[0] as TCalendarMenuOptions
          ) as string;
          delete querystring.start_date;
          delete querystring.end_date;

          if (querystring.page) {
            querystring.page = 1;
          }

          setQuerystring(querystring);
          updateAllPaymentSlipsRef(undefined, formatEndDate);
        }
      }
    } else {
      const dates = select[0].split(" - ");

      const parsedStart =
        dates[0] && typeof dates[0] === "string"
          ? parse(dates[0], "dd/MM/yyyy", new Date())
          : undefined;
      const tempStartDate =
        parsedStart && !isNaN(parsedStart.getTime())
          ? format(parsedStart, "yyyy-MM-dd")
          : "";

      const parsedEnd =
        dates[1] && typeof dates[1] === "string"
          ? parse(dates[1], "dd/MM/yyyy", new Date())
          : undefined;
      const tempEndDate =
        parsedEnd && !isNaN(parsedEnd.getTime())
          ? format(parsedEnd, "yyyy-MM-dd")
          : "";

      if (tempStartDate !== startDateRef.current)
        startDateRef.current = tempStartDate;
      if (tempEndDate !== endDateRef.current) endDateRef.current = tempEndDate;

      querystring.end_date = tempEndDate;
      querystring.start_date = tempStartDate;
      querystring.period = undefined;

      if (querystring.page) {
        querystring.page = 1;
      }

      setQuerystring(querystring);
      setTimeout(() => {
        updateAllPaymentSlipsRef();
      }, 100);
    }
  };

  const handleEntryStatusCustomFilter = (
    index: string,
    _selected: string[],
    setSelected: React.Dispatch<React.SetStateAction<string[]>>,
    selectDataRef: React.MutableRefObject<string[]>,
    prevSelectDataRef: React.MutableRefObject<string[]>,
    setShouldUpdate: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    // Store setSelected for use in onCancel
    entryStatusSetSelectedRef.current = setSelected;

    let currentSelection = entryStatusFilterRef.current;
    prevSelectDataRef.current = [...currentSelection];

    let newSelection: string[] = [];
    if (currentSelection.includes(index)) {
      // Deselect: remove only the clicked index
      newSelection = currentSelection.filter((v) => v !== index);
    } else if (index === "0") {
      // Selecting '0' makes it exclusive
      newSelection = ["0"];
    } else {
      // Add index, but remove '0' if present
      newSelection = currentSelection.filter((v) => v !== "0");
      newSelection.push(index);
    }
    // Ensure only unique values and no empty strings
    newSelection = Array.from(new Set(newSelection)).filter((v) => v !== "");

    entryStatusFilterRef.current = newSelection;
    selectDataRef.current = newSelection;
    setSelected(newSelection);
    setShouldUpdate(true);
    setTimeout(() => setShouldUpdate(false), 20);
  };

  const handleEntryStatusOnClear = () => {
    const queryStrings = getQuerystringParams();

    payablesRef.current = undefined;
    goodsEntryRef.current = undefined;

    delete queryStrings.has_payable_accounts;
    delete queryStrings.has_goods_receipt;

    if (entryStatusRef.current) {
      queryStrings.launch_status = entryStatusRef.current ?? 40;
    }

    if (queryStrings.page) {
      queryStrings.page = 1;
    }

    if (queryStrings.modal) {
      delete queryStrings.modal;
    }

    setQuerystring(queryStrings);

    updateAllPaymentSlipsRef();
  };

  const handleEntryStatusOnAction = (
    selectDataRef: React.MutableRefObject<string[]>
  ) => {
    let hasPayable, hasGoods;

    const queryStrings = getQuerystringParams();

    if (selectDataRef.current.length) {
      if (selectDataRef.current.includes("2")) {
        hasGoods = true;
      }
      if (selectDataRef.current.includes("1")) {
        hasPayable = true;
      }
      if (
        selectDataRef.current.includes("0") &&
        selectDataRef.current.length === 1
      ) {
        hasPayable = false;
        hasGoods = false;
      }
      payablesRef.current = hasPayable;
      goodsEntryRef.current = hasGoods;

      if (hasPayable !== undefined)
        queryStrings.has_payable_accounts = payablesRef.current;

      if (hasGoods !== undefined)
        queryStrings.has_goods_receipt = goodsEntryRef.current;

      if (entryStatusRef.current) {
        queryStrings.launch_status = entryStatusRef.current ?? 40;
      } /* else {
        searchString.delete("launch_status");
      } */

      if (queryStrings.page) {
        queryStrings.page = 1;
      }

      goTo(window.location.pathname, queryStrings);
    } else {
      payablesRef.current = undefined;
      goodsEntryRef.current = undefined;

      delete queryStrings.has_payable_accounts;
      delete queryStrings.has_goods_receipt;

      if (entryStatusRef.current) {
        queryStrings.launch_status = entryStatusRef.current ?? 40;
      } /* else {
        searchString.delete("launch_status");
      } */

      if (queryStrings.page) {
        queryStrings.page = 1;
      }

      goTo(window.location.pathname, queryStrings);
    }
    console.log("fetching payment slips by all entry status");
    fetchPaymentSlipsByAllEntryStatus();
  };

  const handleEntryStatusOnCancel = () => {
    //
  };

  // Returns the default entry status options based on the querystring
  const getDefaultEntryStatusOptions = (queryStrings: TQuerystringParams) => {
    const hasPayableCondition = queryStrings.has_payable_accounts;
    const hasNotEntryCondition = hasPayableCondition === false;

    if (hasNotEntryCondition) return ["0"];
    if (hasPayableCondition) return ["1"];
    return undefined;
  };

  // Set the initial value for the filter ref
  entryStatusFilterRef.current =
    getDefaultEntryStatusOptions(getQuerystringParams()) || [];

  // Pure function for default entry status options
  const handleEntryStatusForceSelectOptions = () => {
    const result = getDefaultEntryStatusOptions(getQuerystringParams());

    return result;
  };

  const fetchInvoicesByAllEntryStatus = async () => {
    if (selectOrganization) {
      setTimeout(async () => {
        if (cancelTokenSource.current)
          await dispatch(
            fetchInvoices({
              cancelToken: cancelTokenSource.current.token,
            })
          )
            .unwrap()
            .then(() => {
              apiService
                .getInvoiceUpdatedAt(
                  selectOrganization.uuid,
                  (cancelTokenSource.current as CancelTokenSource).token
                )
                .then((response) => {
                  dispatch(
                    setInvoicesUpdatedAt({
                      responseStatus: response.status,
                      date: response.data.updated_at,
                    })
                  );
                });
            });
      }, 50);
    }
  };

  const fetchPaymentSlipsByAllEntryStatus = async (_endDate?: string) => {
    setTimeout(() => {
      if (cancelTokenSource.current)
        dispatch(
          fetchModalPaymentSlips({
            cancelToken: cancelTokenSource.current.token,
          })
        )
          .unwrap()
          .then(() => {
            const querystrings = getQuerystringParams();
            apiService
              .getPaymentSlipUpdatedAt(
                querystrings.organization_id,
                (cancelTokenSource.current as CancelTokenSource).token
              )
              .then((response) => {
                dispatch(
                  setPaymentSlipsUpdatedAt({
                    responseStatus: response.status,
                    date: response.data.updated_at,
                  })
                );
              });
          });
    }, 50);
  };

  const handlePeriodForceSelectOptions = () => {
    const queryStrings = getQuerystringParams();

    if (queryStrings.start_date && queryStrings.end_date) {
      startDateRef.current = queryStrings.start_date[0];
      endDateRef.current = queryStrings.end_date[0];

      return [
        queryStrings.start_date[0].replace(
          /(\d{4})-(\d{2})-(\d{2})/,
          "$3/$2/$1"
        ),
        queryStrings.end_date[0].replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1"),
      ];
    }

    const calendarOptions = [
      ...CALENDAR_SLIP_CONTENT_OPTIONS.map((string) => string.toLowerCase()),
    ];

    if (
      queryStrings.period &&
      calendarOptions.includes(
        handleRevertTranslateCalendarOptions(
          queryStrings.period[0] as TCalendarMenuOptions
        ) as string
      )
    ) {
      return [
        calendarOptions.indexOf(
          handleRevertTranslateCalendarOptions(
            queryStrings.period[0] as TCalendarMenuOptions
          ) as string
        ),
      ];
    }

    return undefined;
  };

  const handleSelect = (selected: { elementId: string }[]) => {
    const uuids = selected
      .map((el) => el.elementId)
      .filter((id) => typeof id === "string" && id.length > 0);

    if (uuids.length === 1 && uuids[0] === "all") {
      setSelectedUUIDs(modalPaymentSlipState.results.map((slip) => slip.uuid));
    } else if (uuids.length === 1 && uuids[0] === "none") {
      setSelectedUUIDs([]);
    } else {
      setSelectedUUIDs(uuids);
    }
  };

  const updateAllPaymentSlipsRef = useCallback(
    async (_entryStatus?: number, endDate?: string) => {
      cancelTokenSource.current = axios.CancelToken.source();

      const queryStringParams = getQuerystringParams();

      endDateRef.current = endDate ?? queryStringParams.end_date;
      startDateRef.current = queryStringParams.start_date;
      payablesRef.current = queryStringParams.has_payable_accounts;
      goodsEntryRef.current = queryStringParams.has_goods_receipt;
      pageRef.current = queryStringParams.page;
      itemsPerPageRef.current = queryStringParams.items_per_page;
      entryStatusRef.current = queryStringParams.launch_status as
        | TInvoiceEntryStatus
        | undefined;

      await dispatch(
        fetchModalPaymentSlips({ cancelToken: cancelTokenSource.current.token })
      )
        .unwrap()
        .then((response) => {
          allPaymentSlipsRef.current = response?.results;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    [window.location.search]
  );

  useEffect(() => {
    // Always copy before mutating to avoid read-only errors
    const queryStrings = { ...getQuerystringParams() };

    prevQueryStringsRef.current = { ...queryStrings };

    queryStrings.modal = true;
    delete queryStrings.start_date;
    delete queryStrings.end_date;
    queryStrings.period = "all";
    setQuerystring(queryStrings);
    updateAllPaymentSlipsRef();

    return () => {
      if (prevQueryStringsRef.current) {
        setQuerystring(prevQueryStringsRef.current);
        goTo(window.location.pathname, prevQueryStringsRef.current);
      }

      if (cancelTokenSource.current) cancelTokenSource.current.cancel();
    };
  }, []);

  useEffect(() => {}, [
    modalPaymentSlipState,
    selectedOrganizationWithPermissions,
  ]);

  useEffect(() => {
    // Sync selectedPaymentSlipRows whenever modalPaymentSlipState.results or selectedUUIDs changes
    if (modalPaymentSlipState?.results) {
      setSelectedPaymentSlipRows(
        modalPaymentSlipState.results.filter((slip) =>
          selectedUUIDs.includes(slip.uuid)
        )
      );
    }
  }, [modalPaymentSlipState?.results, selectedUUIDs]);

  return (
    <Container data-testid="link-payment-slip-modal">
      <SearchBarSection>
        <SearchBar
          onClear={() => {
            searchRef.current = undefined;
            if (cancelTokenSource.current) {
              const queryStrings = getQuerystringParams();
              if (queryStrings.organization_id) {
                queryStrings.organization_id = queryStrings.organization_id;
              }
              delete queryStrings.link_payment_slips_search;
              if (entryStatusRef.current) {
                queryStrings.launch_status = entryStatusRef.current ?? 40;
              }
              setQuerystring(queryStrings);
              dispatch(
                fetchModalPaymentSlips({
                  cancelToken: cancelTokenSource.current.token,
                })
              );
            }
          }}
          $ref={(ref, setSearchString) => {
            const queryStrings = getQuerystringParams();
            if (queryStrings.link_payment_slips_search && ref.current) {
              ref.current.value = queryStrings.link_payment_slips_search;
              setSearchString(queryStrings.link_payment_slips_search);
            }
          }}
          onSearch={(searchPhrase) => {
            searchRef.current = searchPhrase;

            const queryStrings = getQuerystringParams();

            if (searchRef.current && searchRef.current.length > 0) {
              queryStrings.link_payment_slips_search = searchRef.current;
            } else {
              delete queryStrings.link_payment_slips_search;
            }
            if (entryStatusRef.current) {
              queryStrings.launch_status = entryStatusRef.current ?? 40;
            }

            if (queryStrings.page) {
              queryStrings.page = 1;
            }

            setQuerystring(queryStrings);
            if (cancelTokenSource.current) {
              dispatch(
                fetchModalPaymentSlips({
                  cancelToken: cancelTokenSource.current.token,
                })
              );
            }
          }}
          variant="default"
          placeholder="Pesquisar"
        />
        <SearchBarSectionSubcontainer id={searchBarContainerId}>
          <DropdownFilter
            buttonVariant="calendar"
            menuVariant="calendar-slip"
            onSelect={handleCalendarOnSelect}
            forceSelectOptionsByIndex={(() => {
              const result = handlePeriodForceSelectOptions();
              return shouldRejectFilledEntryStatus ||
                (result && typeof result[0] === "string")
                ? []
                : (result as number[]);
            })()}
            filled={(() => {
              const result = handlePeriodForceSelectOptions();

              return result === undefined
                ? result
                : typeof result[0] === "string"
                ? (result as string[])
                : [CALENDAR_SLIP_CONTENT_OPTIONS[result[0]]];
            })()}
            onClear={handleCalendarOnClear}
          />
          <DropdownFilter
            buttonVariant="checkCircle"
            placeholder="Lançamentos"
            content={entryStatusOptions}
            menuVariant="unlabeled"
            search={false}
            customFilter={handleEntryStatusCustomFilter}
            onAction={handleEntryStatusOnAction}
            onClear={handleEntryStatusOnClear}
            onCancel={handleEntryStatusOnCancel}
            hasBottomBar
            key={
              getQuerystringParams().has_payable_accounts +
              "" +
              getQuerystringParams().has_goods_receipt
            }
            forceSelectOptionsByIndex={(() => {
              const result = handleEntryStatusForceSelectOptions();
              return shouldRejectFilledEntryStatus
                ? undefined
                : result
                ? result.map(Number)
                : undefined;
            })()}
            filled={(() => {
              const result = handleEntryStatusForceSelectOptions();
              return result === undefined
                ? result
                : [...result.toString().replaceAll(",", "")];
            })()}
          />
        </SearchBarSectionSubcontainer>
      </SearchBarSection>

      <TableGrid
        data-testid="link-payment-slip-tablegrid"
        key={
          modalPaymentSlipState.count +
          "-" +
          shouldUpdateComponent +
          "-invoices-tablegrid"
        }
        row="doubleRow"
        disableBatchOperations
        columns={{
          tableHead: {
            // 12px 50px 160px 230px 250px 200px 160px
            width: [`12px 50px 160px 230px 250px 200px 160px`],
          },
          tableBody: {
            width: [`12px 50px 160px 230px 250px 200px 160px`],
          },
        }}
        onAction={() => {
          window.location.reload();
        }}
        emptyState={{
          isEmptyState:
            !isLoading && modalPaymentSlipState?.results.length === 0,
          title: "Nenhum boleto encontrado",
          description: "Altere os filtros e realize a busca novamente",
        }}
        secondRow={{
          params: modalPaymentSlipState?.results.map((paymentSlip, index) => ({
            data: {
              ...(secondRowFormatter(paymentSlip) as TCellNotTagMiscellaneous),
              skeleton: isLoading
                ? {
                    containerCss: {
                      display: "flex",
                      justifyContent: "space-between",
                      width: "1005px",
                      overflow: "hidden",
                      margin: "0 20px",
                    },
                    values: [
                      { width: "216px", height: "16px" },
                      {
                        width: "96px",
                        height: "16px",
                        style: { maxWidth: "96px", overflow: "hidden" },
                      },
                    ],
                  }
                : undefined,
            },
            leftSideCustomNode: !isLoading && (
              <>
                {paymentSlip.bar_code.length > 0 &&
                  handleSecondRowLeftSideCustomNodeRender(paymentSlip, index)}
              </>
            ),
            rightSideCustomNode: !isLoading && (
              <>
                {handleSecondRowRightSideCustomNodeRender(paymentSlip, index)}
              </>
            ),
          })),
        }}
        onSelect={handleSelect}
        selectType={{
          type: "multiSelect",
          fullData: allPaymentSlipsRef.current,
        }}
        tableHead={{
          value: [
            { style: "noIcon", showSkeleton: isLoading, value: "Enviado em" },
            { style: "noIcon", showSkeleton: isLoading, value: "Origem" },
            { style: "noIcon", showSkeleton: isLoading, value: "Emitente" },
            { style: "noIcon", showSkeleton: isLoading, value: "Valor" },
            {
              style: "noIcon",
              showSkeleton: isLoading,
              value: "Vencimento",
            },
          ],
        }}
        tableBody={
          isLoading
            ? new Array(5).fill("").map(() => ({
                elementId: "",
                file_nfe: null,
                file_xml: null,
                body: [
                  {
                    style: "default",
                    value: "",
                    skeleton: { values: [{ width: "72px" }] },
                  },
                  {
                    style: "default",
                    value: "",
                    skeleton: { values: [{ width: "150px" }] },
                  },
                  {
                    style: "default",
                    value: "",
                    skeleton: { values: [{ width: "177px" }] },
                  },
                  {
                    style: "default",
                    value: "",
                    skeleton: { values: [{ width: "100px" }] },
                  },
                  {
                    style: "default",
                    value: "",
                    skeleton: {
                      values: [
                        { width: "88px", style: { overflow: "hidden" } },
                      ],
                    },
                  },
                ] as TTableBody<TCellStyleVariants>[],
              }))
            : (modalPaymentSlipState?.results ?? []).map(
                (paymentSlip: TPaymentSlip, index: number) => ({
                  elementId: paymentSlip.uuid,
                  file_nfe: null,
                  file_xml: null,
                  body: rowFormatter(paymentSlip, index),
                })
              )
        }
        isLoading={isLoading}
        footer={{
          customStyle: {
            width: "1068px",
          },
          formButtons: {
            buttons: [
              (() => {
                const cancelButton = { ...footer.buttons[0] };

                cancelButton.onClick = () => {
                  if (footer.buttons[0].onClick) {
                    footer.buttons[0].onClick();
                    setSelectedPaymentSlipRows([]);
                    setShouldUpdateComponent(true);
                    setTimeout(() => {
                      setShouldUpdateComponent(false);
                    }, 100);
                  }
                };
                return cancelButton;
              })(),
              (() => {
                const actionButton = { ...footer.buttons[1] };
                if (selectedPaymentSlipRows.length === 0) {
                  actionButton.disabled = true;
                  actionButton.text = "Confirmar selecionado";
                }

                if (selectedPaymentSlipRows.length > 0) {
                  actionButton.disabled = false;
                  actionButton.text = "Confirmar selecionado";
                }

                if (selectedPaymentSlipRows.length > 1) {
                  actionButton.text = "Confirmar selecionados";
                }

                actionButton.onClick = () => {
                  if (footer.buttons[1].onClick) {
                    footer.buttons[1].onClick({
                      selectedPaymentSlips: selectedPaymentSlipRows,
                      clearSelectedPaymentSlips: () => {
                        setShouldUpdateComponent(true);
                        setTimeout(() => {
                          setShouldUpdateComponent(false);
                        }, 100);
                      },
                    });
                  }
                };

                return actionButton;
              })(),
            ],
          },
          leftSideDescription:
            " | Total de " +
            modalPaymentSlipState.count +
            (modalPaymentSlipState.count > 1
              ? " registros encontrados"
              : " registro encontrado"),
          onSelectItemsPerPage(amount) {
            const querystring = getQuerystringParams();

            pageRef.current = 1;

            querystring.page = pageRef.current;
            querystring.items_per_page = amount;

            goTo(window.location.pathname, querystring);

            if (/* selectOrganization &&  */ cancelTokenSource.current) {
              dispatch(
                fetchModalPaymentSlips({
                  cancelToken: cancelTokenSource.current.token,
                })
              );
            }
          },
          customPagination: modalPaymentSlipState
            ? {
                fixedBottom: { isFixedAtTheBottom: true },
                currentPage: `${modalPaymentSlipState?.current_page}`,
                buttonBackward: {
                  disabled: modalPaymentSlipState.current_page === 1,
                  onClick() {
                    pageRef.current = modalPaymentSlipState.current_page - 1;

                    const queryStrings = getQuerystringParams();

                    if (queryStrings.items_per_page) {
                      itemsPerPageRef.current = queryStrings.items_per_page;
                    }

                    handleSetDataToLocalStorage(
                      localStorageConstants.CURRENT_PAGE,
                      pageRef.current
                    );

                    if (
                      selectOrganization &&
                      modalPaymentSlipState.current_page !== 1 &&
                      cancelTokenSource.current
                    ) {
                      if (pageRef.current) queryStrings.page = pageRef.current;
                      goTo(window.location.pathname, queryStrings);

                      dispatch(
                        fetchModalPaymentSlips({
                          cancelToken: cancelTokenSource.current.token,
                        })
                      );
                    }
                  },
                },
                buttonForward: {
                  disabled:
                    modalPaymentSlipState.current_page ===
                    modalPaymentSlipState.pages.length,
                  onClick() {
                    if (
                      modalPaymentSlipState.current_page ===
                      modalPaymentSlipState.pages.length
                    ) {
                      pageRef.current = modalPaymentSlipState.current_page;
                    } else {
                      pageRef.current = modalPaymentSlipState.current_page + 1;
                    }

                    const queryStrings = handleParseQuerystrings(
                      window.location.search
                    );

                    if (queryStrings.items_per_page) {
                      itemsPerPageRef.current = parseInt(
                        queryStrings.items_per_page[0]
                      );
                    }

                    handleSetDataToLocalStorage(
                      localStorageConstants.CURRENT_PAGE,
                      pageRef.current
                    );

                    if (
                      selectOrganization &&
                      modalPaymentSlipState.current_page !==
                        modalPaymentSlipState.pages.length &&
                      cancelTokenSource.current
                    ) {
                      const queryStrings = getQuerystringParams();
                      if (pageRef.current) queryStrings.page = pageRef.current;

                      goTo(window.location.pathname, queryStrings);

                      dispatch(
                        fetchModalPaymentSlips({
                          cancelToken: cancelTokenSource.current.token,
                        })
                      );
                    }
                  },
                },
                pages: modalPaymentSlipState.pages.map((page) => {
                  return {
                    value: Object.keys(page)[0],
                    onClick() {
                      let temp =
                        Object.values(page)[0].match(/.*?page=(\d+)&per_/);

                      if (temp !== null && temp[1]) {
                        pageRef.current = parseInt(temp[1]);
                      } else {
                        pageRef.current = 1;
                      }

                      const queryStrings = getQuerystringParams();

                      if (queryStrings.items_per_page) {
                        itemsPerPageRef.current = queryStrings.items_per_page;
                      }

                      handleSetDataToLocalStorage(
                        localStorageConstants.CURRENT_PAGE,
                        pageRef.current
                      );

                      if (selectOrganization && cancelTokenSource.current) {
                        const queryStrings = getQuerystringParams();
                        if (pageRef.current)
                          queryStrings.page = pageRef.current;
                        goTo(window.location.pathname, queryStrings);

                        dispatch(
                          fetchModalPaymentSlips({
                            cancelToken: cancelTokenSource.current.token,
                          })
                        );
                      }
                    },
                  };
                }),
              }
            : undefined,
        }}
      />

      <Modal
        key={invoiceToBreakLink?.target.uuid}
        title="Remover vínculo"
        icon={{ type: "breakLink", color: "red" }}
        main={{
          style: "textOnly",
          content: [
            {
              text: "Tem certeza que deseja remover o vínculo com esta nota fiscal?",

              style: "default",
              shouldBreakLine: false,
            },
          ],
        }}
        footer={{
          style: "default",
          buttons: [
            {
              variant: "secondary",
              icon: "noIcon",
              text: "Cancelar",
              onClick() {
                setInvoiceToBreakLink(undefined);
              },
            },
            {
              variant: "red",
              iconPosition: "left",
              icon: "checkmark",
              text: "Sim, remover",
              onClick() {
                if (invoiceToBreakLink) {
                  apiService
                    .detachInvoiceFromPaymentSlip(
                      invoiceToBreakLink.origin.uuid,
                      invoiceToBreakLink.target.uuid,
                      (cancelTokenSource.current as CancelTokenSource).token
                    )
                    .then(() => {
                      setInvoiceToBreakLink(undefined);
                      dispatch(
                        setToastState({
                          variant: "success",
                          shouldShow: true,
                          message: {
                            title: "Sucesso",
                            description: "Vínculo removido",
                          },
                        })
                      );
                      fetchPaymentSlipsByAllEntryStatus();
                      fetchInvoicesByAllEntryStatus();
                    })
                    .catch(() => {
                      setInvoiceToBreakLink(undefined);
                      dispatch(
                        setToastState({
                          variant: "error",
                          shouldShow: true,
                          message: {
                            title: "Erro",
                            description:
                              "Não foi possível remover o vínculo, tente novamente",
                          },
                        })
                      );
                    });
                }
              },
            },
          ],
        }}
        shouldOpen={invoiceToBreakLink !== undefined}
        onClose={() => {
          setInvoiceToBreakLink(undefined);
        }}
      />
    </Container>
  );
};

export default LinkPaymentSlip;
